// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uMxuJ0yrwKVu2_ {
  position: relative;
  width: 240px;
  margin-bottom: 16px;
  margin-bottom: 15px;
}
.uMxuJ0yrwKVu2_ h1 {
  margin-top: 16px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  margin: 0;
  padding: 8px 12px;
}
.uMxuJ0yrwKVu2_ .xwrCRjxjcoKwnq a {
  display: block;
  margin-bottom: 4px;
  padding: 8px 12px;
  border-radius: 8px;
  color: var(--ds-text, #172b4d);
  font-weight: 500;
  text-decoration: none;
}
.uMxuJ0yrwKVu2_ .xwrCRjxjcoKwnq a:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
a.uMxuJ0yrwKVu2_ .xwrCRjxjcoKwnq a:hover {
  text-decoration: none;
}
.uMxuJ0yrwKVu2_ .xwrCRjxjcoKwnq a:active {
  background-color: var(--ds-background-neutral-pressed, #091e424f);
}
.uMxuJ0yrwKVu2_ .xwrCRjxjcoKwnq a.DEV_nhTSK0D0sd {
  background-color: var(--ds-background-selected, #e9f2ff);
  color: var(--ds-text-selected, #0c66e4);
}
.wcCTIyQxEDS8Dr {
  margin: 12px 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterList": `uMxuJ0yrwKVu2_`,
	"filter": `xwrCRjxjcoKwnq`,
	"active": `DEV_nhTSK0D0sd`,
	"horizontalSeparator": `wcCTIyQxEDS8Dr`
};
export default ___CSS_LOADER_EXPORT___;
